"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CAN_GO_BACK = exports.CALENDAR_PATH = exports.BG_STREAMS_URL = exports.BETSLIP_CONNECTION_ERROR = exports.BETGENIUS_CONFIG = exports.BASKETBALL_SPORT_ID = exports.BACKGROUND_IMAGE_LIVE_BANNER_VOLLEYBALL = exports.BACKGROUND_IMAGE_LIVE_BANNER_UFCMMA = exports.BACKGROUND_IMAGE_LIVE_BANNER_TENNIS = exports.BACKGROUND_IMAGE_LIVE_BANNER_TABLETENNIS = exports.BACKGROUND_IMAGE_LIVE_BANNER_SNOOKER = exports.BACKGROUND_IMAGE_LIVE_BANNER_RUGBYLEAGUE = exports.BACKGROUND_IMAGE_LIVE_BANNER_RUGBY = exports.BACKGROUND_IMAGE_LIVE_BANNER_ICEHOCKEY = exports.BACKGROUND_IMAGE_LIVE_BANNER_HORSERACING = exports.BACKGROUND_IMAGE_LIVE_BANNER_HANDBALL = exports.BACKGROUND_IMAGE_LIVE_BANNER_GREYHOUNDS = exports.BACKGROUND_IMAGE_LIVE_BANNER_FUTSAL = exports.BACKGROUND_IMAGE_LIVE_BANNER_FORMULA1 = exports.BACKGROUND_IMAGE_LIVE_BANNER_FOOTBALL = exports.BACKGROUND_IMAGE_LIVE_BANNER_FIELDHOCKEY = exports.BACKGROUND_IMAGE_LIVE_BANNER_ESPORTS = exports.BACKGROUND_IMAGE_LIVE_BANNER_DEFAULT = exports.BACKGROUND_IMAGE_LIVE_BANNER_DARTS = exports.BACKGROUND_IMAGE_LIVE_BANNER_CRYPTO = exports.BACKGROUND_IMAGE_LIVE_BANNER_CRICKET = exports.BACKGROUND_IMAGE_LIVE_BANNER_BOWLS = exports.BACKGROUND_IMAGE_LIVE_BANNER_BEACHVOLLEYBALL = exports.BACKGROUND_IMAGE_LIVE_BANNER_BEACHSOCCER = exports.BACKGROUND_IMAGE_LIVE_BANNER_BASKETBALL = exports.BACKGROUND_IMAGE_LIVE_BANNER_BASEBALL = exports.BACKGROUND_IMAGE_LIVE_BANNER_BADMINTON = exports.BACKGROUND_IMAGE_LIVE_BANNER_AMERICANFOOTBALL = exports.API_VIRTUALS_VFL = exports.API_VIRTUALS_GR = exports.API_VIRTUALS = exports.API_VERIFICATION = exports.API_TRANSACTIONS = exports.API_STARBUCK = exports.API_SSO = exports.API_SIS = exports.API_SEED_PERFORM = exports.API_PORTAL = exports.API_PERFORM = exports.API_OPM = exports.API_MERLIN = exports.API_LOGOUT = exports.API_IPOOLS_POOL_ENTRY = exports.API_IPOOLS_POOL_ENTRIES = exports.API_IPOOLS_POOL = exports.API_IPOOLS_LEADERBOARD = exports.API_IPOOLS = exports.API_GAMING_LICENSE = exports.API_COUPONS = exports.API_CMS = exports.API_CHANGE_ONE_TIME_PASSWORD = exports.API_CASINO_DATA = exports.API_CASINO = exports.API_BLOG_POSTS = exports.API_BETSLIP = exports.API_BETGENIUS = exports.API_AUTH = exports.ALL_LEAGUES_PATH = exports.AFFILIATE_PATHS = exports.AFFILIATE_PATH = exports.ACCOUNT_PATH = exports.ACCOUNT_PAGE_PATHS = void 0;
Object.defineProperty(exports, "CASINO_PATH", {
  enumerable: true,
  get: function get() {
    return _constants.CASINO_PATH;
  }
});
exports.FOOTER_ID_LINK_LIVE_CASINO = exports.FOOTER_ID_LINK_LIVE = exports.FOOTER_ID_LINK_JACKPOT_GAMES = exports.FOOTER_ID_LINK_JACKPOT = exports.FOOTER_ID_LINK_GOLF = exports.FOOTER_ID_LINK_GAMING_LICENSE = exports.FOOTER_ID_LINK_FOOTBALL = exports.FOOTER_ID_LINK_FAQ = exports.FOOTER_ID_LINK_E_SPORTS = exports.FOOTER_ID_LINK_COOKIE_POLICY = exports.FOOTER_ID_LINK_CONTACTS = exports.FOOTER_ID_LINK_CHAMPIONS_LEAGUE = exports.FOOTER_ID_LINK_CASINO = exports.FOOTER_ID_LINK_BOXING = exports.FOOTER_ID_LINK_BONUS = exports.FOOTER_ID_LINK_BLOG = exports.FOOTER_ID_LINK_BETBUILDER = exports.FOOTER_ID_LINK_BASKETBALL = exports.FOOTER_ID_LINK_BASEBALL = exports.FOOTER_ID_LINK_AFFILIATES = exports.FOOTER_ID_LINK_ABOUT_US = exports.FOOTER_ID_LINK = exports.FOOTBALL_SPORT_ID = exports.FAVORITES = exports.EVENT_ID_PARAM = exports.DESKTOP = exports.DEBOUNCE_SEND_EMAIL_VERIFICATION = exports.DEBOUNCE_RESET_PASSWORD = exports.COUPON_HEADER_PATH = exports.COOKIES_POLICY_PATH = exports.COOKIES_BANNER_COOKIE_WITH_MARKETING_KEY = exports.COOKIES_BANNER_COOKIE_KEY = void 0;
exports.LIVE_EVENT_PATH = exports.LIVE_CASINO_PATH = exports.LIVE_ALL_SPORTS_ID = exports.LICENSE_PATH = exports.LEAGUE_SPORT_COUPON_PATH = exports.IPOOLS_SETTLED_STATE_COOKIE = exports.IPOOLS_PATH = exports.IPOOLS_EVENT_PATH = exports.INITIAL_STATE_VAR = exports.INBOUND_API = exports.HORSERACING_ID = exports.GREYHOUNDS_ID = exports.GA_ATTRIBUTES_VALUES = exports.GA_ATTRIBUTES_KEYS = exports.FOOTER_QA_ID = exports.FOOTER_ID_LINK_VOLLEYBALL = exports.FOOTER_ID_LINK_VIRTUALS = exports.FOOTER_ID_LINK_VIDE0_SLOTS = exports.FOOTER_ID_LINK_TUTORIALS = exports.FOOTER_ID_LINK_TRAGAMONEDAS = exports.FOOTER_ID_LINK_TERMS_AND_CONDITIONS = exports.FOOTER_ID_LINK_TENNIS = exports.FOOTER_ID_LINK_TABLE_GAMES = exports.FOOTER_ID_LINK_SPORTSBOOK = exports.FOOTER_ID_LINK_SLOTS = exports.FOOTER_ID_LINK_SITE_SECURITY = exports.FOOTER_ID_LINK_RESPONSIBLE_GAMING = exports.FOOTER_ID_LINK_PROMOTIONS = exports.FOOTER_ID_LINK_PRIVACY_POLICY = exports.FOOTER_ID_LINK_PREMIER_LEAGUE = exports.FOOTER_ID_LINK_PREDICTIONS = exports.FOOTER_ID_LINK_POKER = exports.FOOTER_ID_LINK_OTHER_GAMES = void 0;
Object.defineProperty(exports, "LIVE_PATH", {
  enumerable: true,
  get: function get() {
    return _constants.LIVE_PATH;
  }
});
exports.PREMATCH_LIVE_VIRTUALS_PATH = exports.PREMATCH_LIVE_PATH = exports.PREMATCH_EVENT_PATH = exports.PREMATCH_BREADCRUMBS_PATH = exports.POST_REGISTRATION_PATH = exports.OUTRIGHT_FOOTBALL_MARKET_TYPE_ID = exports.OUTRIGHTS_COUPON_PATH = exports.OPM_QA_ID_FORM = exports.MOBILE = exports.MIN_SEARCH_INPUT_VALUE_LENGTH = exports.LOGIN_PATH = exports.LIVE_SPORT_PATH = exports.LIVE_SEARCH_PATH = void 0;
Object.defineProperty(exports, "PREMATCH_PATH", {
  enumerable: true,
  get: function get() {
    return _constants.PREMATCH_PATH;
  }
});
exports.WALLETS_PATH = exports.VIRTUALS_PATH = exports.VERIFY_REPEAT_EMAIL_LOGIN = exports.VERIFY_PASSWORD = exports.VERIFY_EMAIL = exports.VERIFY_ALL = exports.VALIDATE_TOKEN = exports.TRUSTLY_WITHDRAWAL = exports.TRUSTLY_URL = exports.TRUSTLY_TOKEN = exports.TRUSTLY_REGISTRATION = exports.TRUSTLY_LOGIN = exports.TRUSTLY_DEPOSIT = exports.TRANSACTIONS_PATH = exports.TOP_LEAGUES_PATH = exports.TIME_CACHE_SEO_FILES = exports.TIME_CACHE_LICENSE = exports.TENNIS_SPORT_ID = exports.TABLET = exports.SPORT_TABS_PATH = exports.SPORT_PAGE_PATH = exports.SPORT_LEAGUE_TABS_PATH = exports.SPORT_ID_PARAM = exports.SPORT_IDS = exports.SPORT_FILTER_PATH = exports.SPORT_COUPON_PATH = exports.SPORTSMENU_PATH = exports.SITEMAP_PATH = exports.SEASONAL_PROMOTION_PATH = exports.SEARCH_PATH_QUERY_PARAM = exports.SEARCH_PATH = exports.SCHEDULE_PATH = exports.RUNTIME_CONFIG = exports.RESET_PASSWORD_PATH = exports.RESEND_EMAIL = exports.REGISTRATION_PATH = exports.REGISTRATION_BONUS_COOKIE_KEY = exports.REGISTER_VERIFICATION_EMAIL = exports.REGISTER_VERIFICATION = exports.PROMOTIONS_SEARCH_ROUTE = exports.PROMOTIONS_ROUTE = exports.PROMOTIONS_PATH = exports.PROMOTIONS_CASINO_ROUTE = exports.PREREGISTRATION_PATH = exports.PREMATCH_SEARCH_PATH = void 0;
var _constants = require("@sminpmjs/constants");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/*
  Devices
*/

var DESKTOP = exports.DESKTOP = 'desktop';
var MOBILE = exports.MOBILE = 'mobile';
var TABLET = exports.TABLET = 'tablet';

/*
  Promotions
*/

var PROMOTIONS_PATH = exports.PROMOTIONS_PATH = '/promotions';
var PROMOTIONS_CASINO_ROUTE = exports.PROMOTIONS_CASINO_ROUTE = "".concat(PROMOTIONS_PATH, "/casino");
var PROMOTIONS_SEARCH_ROUTE = exports.PROMOTIONS_SEARCH_ROUTE = "".concat(PROMOTIONS_PATH, "/search");
var PROMOTIONS_ROUTE = exports.PROMOTIONS_ROUTE = "".concat(PROMOTIONS_PATH, "/:promotionsType?");
var SEASONAL_PROMOTION_PATH = exports.SEASONAL_PROMOTION_PATH = '/promo';

/*
  Virtuals and Ipools
*/
var VIRTUALS_PATH = exports.VIRTUALS_PATH = '/virtuals';
var IPOOLS_PATH = exports.IPOOLS_PATH = '/ipools';
var IPOOLS_EVENT_PATH = exports.IPOOLS_EVENT_PATH = "".concat(IPOOLS_PATH, "/:gameId");
var COOKIES_POLICY_PATH = exports.COOKIES_POLICY_PATH = "/cookies_policy";
var LIVE_CASINO_PATH = exports.LIVE_CASINO_PATH = '/live_casino';
var SITEMAP_PATH = exports.SITEMAP_PATH = '/sitemap';

/*
  Live paths
*/

var CALENDAR_PATH = exports.CALENDAR_PATH = "".concat(_constants.LIVE_PATH, "/calendar");
var SCHEDULE_PATH = exports.SCHEDULE_PATH = "".concat(_constants.LIVE_PATH, "/schedule");
var LIVE_SEARCH_PATH = exports.LIVE_SEARCH_PATH = "".concat(_constants.LIVE_PATH, "/search");
var LIVE_EVENT_PREFIX_PATH = '/events';
var LIVE_SPORTS_PREFIX_PATH = '/sports';
var EVENT_ID_PARAM = exports.EVENT_ID_PARAM = 'eventId';
var SPORT_ID_PARAM = exports.SPORT_ID_PARAM = 'sportId';
var LIVE_EVENT_PATH = exports.LIVE_EVENT_PATH = "".concat(_constants.LIVE_PATH).concat(LIVE_EVENT_PREFIX_PATH, "/:").concat(EVENT_ID_PARAM);
var LIVE_SPORT_PATH = exports.LIVE_SPORT_PATH = "".concat(_constants.LIVE_PATH).concat(LIVE_SPORTS_PREFIX_PATH, "/:").concat(SPORT_ID_PARAM);

/* QA ids */

var FOOTER_QA_ID = exports.FOOTER_QA_ID = 'footer_qa_id';
var FOOTER_ID_LINK = exports.FOOTER_ID_LINK = 'footer_id_link';
var FOOTER_ID_LINK_SPORTSBOOK = exports.FOOTER_ID_LINK_SPORTSBOOK = "".concat(FOOTER_ID_LINK, "_sportsbook");
var FOOTER_ID_LINK_FOOTBALL = exports.FOOTER_ID_LINK_FOOTBALL = "".concat(FOOTER_ID_LINK, "_football");
var FOOTER_ID_LINK_BASKETBALL = exports.FOOTER_ID_LINK_BASKETBALL = "".concat(FOOTER_ID_LINK, "_basketball");
var FOOTER_ID_LINK_TENNIS = exports.FOOTER_ID_LINK_TENNIS = "".concat(FOOTER_ID_LINK, "_tennis");
var FOOTER_ID_LINK_VOLLEYBALL = exports.FOOTER_ID_LINK_VOLLEYBALL = "".concat(FOOTER_ID_LINK, "_volleyball");
var FOOTER_ID_LINK_BASEBALL = exports.FOOTER_ID_LINK_BASEBALL = "".concat(FOOTER_ID_LINK, "_baseball");
var FOOTER_ID_LINK_BOXING = exports.FOOTER_ID_LINK_BOXING = "".concat(FOOTER_ID_LINK, "_boxing");
var FOOTER_ID_LINK_GOLF = exports.FOOTER_ID_LINK_GOLF = "".concat(FOOTER_ID_LINK, "_golf");
var FOOTER_ID_LINK_VIRTUALS = exports.FOOTER_ID_LINK_VIRTUALS = "".concat(FOOTER_ID_LINK, "_virtuals");
var FOOTER_ID_LINK_COOKIE_POLICY = exports.FOOTER_ID_LINK_COOKIE_POLICY = "".concat(FOOTER_ID_LINK, "_cookies-policy");
var FOOTER_ID_LINK_CHAMPIONS_LEAGUE = exports.FOOTER_ID_LINK_CHAMPIONS_LEAGUE = "".concat(FOOTER_ID_LINK, "_champions-league");
var FOOTER_ID_LINK_PREMIER_LEAGUE = exports.FOOTER_ID_LINK_PREMIER_LEAGUE = "".concat(FOOTER_ID_LINK, "_premier-league");
var FOOTER_ID_LINK_FAQ = exports.FOOTER_ID_LINK_FAQ = "".concat(FOOTER_ID_LINK, "_faq");
var FOOTER_ID_LINK_CONTACTS = exports.FOOTER_ID_LINK_CONTACTS = "".concat(FOOTER_ID_LINK, "_contacts");
var FOOTER_ID_LINK_TERMS_AND_CONDITIONS = exports.FOOTER_ID_LINK_TERMS_AND_CONDITIONS = "".concat(FOOTER_ID_LINK, "_terms-conditions");
var FOOTER_ID_LINK_ABOUT_US = exports.FOOTER_ID_LINK_ABOUT_US = "".concat(FOOTER_ID_LINK, "_about-us");
var FOOTER_ID_LINK_PRIVACY_POLICY = exports.FOOTER_ID_LINK_PRIVACY_POLICY = "".concat(FOOTER_ID_LINK, "_privacy-policy");
var FOOTER_ID_LINK_PROMOTIONS = exports.FOOTER_ID_LINK_PROMOTIONS = "".concat(FOOTER_ID_LINK, "_promotions");
var FOOTER_ID_LINK_PREDICTIONS = exports.FOOTER_ID_LINK_PREDICTIONS = "".concat(FOOTER_ID_LINK, "_predictions");
var FOOTER_ID_LINK_TABLE_GAMES = exports.FOOTER_ID_LINK_TABLE_GAMES = "".concat(FOOTER_ID_LINK, "_table-games");
var FOOTER_ID_LINK_LIVE_CASINO = exports.FOOTER_ID_LINK_LIVE_CASINO = "".concat(FOOTER_ID_LINK, "_live-casino");
var FOOTER_ID_LINK_AFFILIATES = exports.FOOTER_ID_LINK_AFFILIATES = "".concat(FOOTER_ID_LINK, "_affiliates");
var FOOTER_ID_LINK_BLOG = exports.FOOTER_ID_LINK_BLOG = "".concat(FOOTER_ID_LINK, "_blog");
var FOOTER_ID_LINK_E_SPORTS = exports.FOOTER_ID_LINK_E_SPORTS = "".concat(FOOTER_ID_LINK, "_e-sports");
var FOOTER_ID_LINK_TRAGAMONEDAS = exports.FOOTER_ID_LINK_TRAGAMONEDAS = "".concat(FOOTER_ID_LINK, "_tragamonedas");
var FOOTER_ID_LINK_LIVE = exports.FOOTER_ID_LINK_LIVE = "".concat(FOOTER_ID_LINK, "_live");
var FOOTER_ID_LINK_GAMING_LICENSE = exports.FOOTER_ID_LINK_GAMING_LICENSE = "".concat(FOOTER_ID_LINK, "_gaming-license");
var FOOTER_ID_LINK_CASINO = exports.FOOTER_ID_LINK_CASINO = "".concat(FOOTER_ID_LINK, "_casino");
var FOOTER_ID_LINK_BETBUILDER = exports.FOOTER_ID_LINK_BETBUILDER = "".concat(FOOTER_ID_LINK, "_betbuilder");
var FOOTER_ID_LINK_VIDE0_SLOTS = exports.FOOTER_ID_LINK_VIDE0_SLOTS = "".concat(FOOTER_ID_LINK, "_video-slots");
var FOOTER_ID_LINK_JACKPOT_GAMES = exports.FOOTER_ID_LINK_JACKPOT_GAMES = "".concat(FOOTER_ID_LINK, "_jackpot-games");
var FOOTER_ID_LINK_OTHER_GAMES = exports.FOOTER_ID_LINK_OTHER_GAMES = "".concat(FOOTER_ID_LINK, "_other-games");
var FOOTER_ID_LINK_SITE_SECURITY = exports.FOOTER_ID_LINK_SITE_SECURITY = "".concat(FOOTER_ID_LINK, "_site-security");
var FOOTER_ID_LINK_BONUS = exports.FOOTER_ID_LINK_BONUS = "".concat(FOOTER_ID_LINK, "_bonus");
var FOOTER_ID_LINK_RESPONSIBLE_GAMING = exports.FOOTER_ID_LINK_RESPONSIBLE_GAMING = "".concat(FOOTER_ID_LINK, "_responsible-gaming");
var FOOTER_ID_LINK_TUTORIALS = exports.FOOTER_ID_LINK_TUTORIALS = "".concat(FOOTER_ID_LINK, "_tutorials");
var FOOTER_ID_LINK_POKER = exports.FOOTER_ID_LINK_POKER = "".concat(FOOTER_ID_LINK, "_poker");
var FOOTER_ID_LINK_SLOTS = exports.FOOTER_ID_LINK_SLOTS = "".concat(FOOTER_ID_LINK, "_slots");
var FOOTER_ID_LINK_JACKPOT = exports.FOOTER_ID_LINK_JACKPOT = "".concat(FOOTER_ID_LINK, "_jackpot");
var OPM_QA_ID_FORM = exports.OPM_QA_ID_FORM = 'opm_qa_id_form';
/*
  Prematch paths
*/

var PREMATCH_SEARCH_PATH = exports.PREMATCH_SEARCH_PATH = "".concat(_constants.PREMATCH_PATH, "/search");
var SPORTSMENU_PATH = exports.SPORTSMENU_PATH = "".concat(_constants.PREMATCH_PATH, "/:sportId?/:regionIds?/:leagueIds?/:eventId?");
var PREMATCH_BREADCRUMBS_PATH = exports.PREMATCH_BREADCRUMBS_PATH = '/:sportId/:regionOrCoupon?/:leagueIds?/:eventId?';

// eslint-disable-next-line max-len
var SPORT_FILTER_PATH = exports.SPORT_FILTER_PATH = "".concat(_constants.PREMATCH_PATH, "/:sportId/:regionIds([0-9,]+)/:leagueIds([0-9,]+)?");

// eslint-disable-next-line max-len
var SPORT_PAGE_PATH = exports.SPORT_PAGE_PATH = "".concat(_constants.PREMATCH_PATH, "/:sportId([0-9,]+)");
var SPORT_COUPON_PATH = exports.SPORT_COUPON_PATH = "".concat(SPORT_PAGE_PATH, "/:regionIds([0-9,]+)?/:leagueIds([0-9,]+)?");
var LEAGUE_SPORT_COUPON_PATH = exports.LEAGUE_SPORT_COUPON_PATH = "".concat(SPORT_PAGE_PATH, "/:regionIds([0-9,]+)/:leagueIds([0-9,]+)");
var SPORT_LEAGUE_TABS_PATH = exports.SPORT_LEAGUE_TABS_PATH = "".concat(LEAGUE_SPORT_COUPON_PATH, "/(outrights)?");
var OUTRIGHTS_COUPON_PATH = exports.OUTRIGHTS_COUPON_PATH = "".concat(LEAGUE_SPORT_COUPON_PATH, "/outrights");
var PREMATCH_EVENT_PATH = exports.PREMATCH_EVENT_PATH = "".concat(_constants.PREMATCH_PATH, "/:sportId/:regionIds/:leagueIds/:eventId");
var COUPON_HEADER_PATH = exports.COUPON_HEADER_PATH = "".concat(_constants.PREMATCH_PATH, "/:sportId");
var SPORT_TABS_PATH = exports.SPORT_TABS_PATH = "".concat(_constants.PREMATCH_PATH, "/:sportId/:regionOrCoupon?");
var TOP_LEAGUES_PATH = exports.TOP_LEAGUES_PATH = "".concat(_constants.PREMATCH_PATH, "/:sportId/topLeagues");
var ALL_LEAGUES_PATH = exports.ALL_LEAGUES_PATH = "".concat(_constants.PREMATCH_PATH, "/:sportId/allLeagues");
var PREMATCH_LIVE_PATH = exports.PREMATCH_LIVE_PATH = "(".concat(_constants.LIVE_PATH, "|").concat(_constants.PREMATCH_PATH, ")");
var PREMATCH_LIVE_VIRTUALS_PATH = exports.PREMATCH_LIVE_VIRTUALS_PATH = "(".concat(_constants.LIVE_PATH, "|").concat(_constants.PREMATCH_PATH, "|").concat(VIRTUALS_PATH, ")");

/*
  Account and Registration
*/

var ACCOUNT_PATH = exports.ACCOUNT_PATH = '/account';
var REGISTRATION_PATH = exports.REGISTRATION_PATH = '/registration';
var PREREGISTRATION_PATH = exports.PREREGISTRATION_PATH = '/prereg';
var AFFILIATE_PATH = exports.AFFILIATE_PATH = '/affiliate';
var POST_REGISTRATION_PATH = exports.POST_REGISTRATION_PATH = '/postregistration';
var AFFILIATE_PATHS = exports.AFFILIATE_PATHS = {
  home: "".concat(AFFILIATE_PATH, "/home"),
  signup: "".concat(AFFILIATE_PATH, "/signup"),
  commission: "".concat(AFFILIATE_PATH, "/commission"),
  products: "".concat(AFFILIATE_PATH, "/products"),
  contacts: "".concat(AFFILIATE_PATH, "/contacts"),
  faq: "".concat(AFFILIATE_PATH, "/faq"),
  testimonials: "".concat(AFFILIATE_PATH, "/testimonials"),
  terms: "".concat(AFFILIATE_PATH, "/terms"),
  sitemap: "".concat(AFFILIATE_PATH, "/sitemap"),
  bonus: "".concat(AFFILIATE_PATH, "/bonus")
};
var ACCOUNT_PAGE_PATHS = exports.ACCOUNT_PAGE_PATHS = {
  betshistory: "".concat(ACCOUNT_PATH, "/betshistory"),
  deposit: "".concat(ACCOUNT_PATH, "/deposit"),
  withdraw: "".concat(ACCOUNT_PATH, "/withdrawal"),
  opmFailUrl: "".concat(ACCOUNT_PATH, "/(deposit|withdrawal)/fail"),
  opmSuccesUrl: "".concat(ACCOUNT_PATH, "/(deposit|withdrawal)/success"),
  opmPendingUrl: "".concat(ACCOUNT_PATH, "/(deposit|withdrawal)/pending"),
  depositWithdrawForms: "".concat(ACCOUNT_PATH, "/(deposit|withdrawal)/:provider"),
  transactions: "".concat(ACCOUNT_PATH, "/transactions"),
  bonus: "".concat(ACCOUNT_PATH, "/bonus"),
  profile: "".concat(ACCOUNT_PATH, "/profile"),
  pendingWithdrawal: "".concat(ACCOUNT_PATH, "/pendingWithdrawal"),
  responsibleGaming: "".concat(ACCOUNT_PATH, "/responsibleGaming"),
  selfAssessment: "".concat(ACCOUNT_PATH, "/selfAssessment"),
  selfExclusion: "".concat(ACCOUNT_PATH, "/selfExclusion"),
  cookieSettings: "".concat(ACCOUNT_PATH, "/cookie-settings")
};

/*
  Search
*/

var SEARCH_PATH = exports.SEARCH_PATH = '/search';
var SEARCH_PATH_QUERY_PARAM = exports.SEARCH_PATH_QUERY_PARAM = 'query';
var LOGIN_PATH = exports.LOGIN_PATH = '/login';
var CAN_GO_BACK = exports.CAN_GO_BACK = 'canGoBack';
var TRANSACTIONS_PATH = exports.TRANSACTIONS_PATH = '/transactions';
var WALLETS_PATH = exports.WALLETS_PATH = '/wallets';

/* API */

var API_PORTAL = exports.API_PORTAL = '/api/portal';
var API_STARBUCK = exports.API_STARBUCK = '/api/starbuck';
var API_BETSLIP = exports.API_BETSLIP = '/api/betslip';
var API_AUTH = exports.API_AUTH = '/api/auth';
var API_BETGENIUS = exports.API_BETGENIUS = '/api/betgenius';
var API_SIS = exports.API_SIS = '/api/sis';
var API_PERFORM = exports.API_PERFORM = '/api/perform';
var API_SEED_PERFORM = exports.API_SEED_PERFORM = '/api/seedPerform';
var API_CASINO = exports.API_CASINO = '/api/casino';
var API_CASINO_DATA = exports.API_CASINO_DATA = '/api/casino-data';
var API_TRANSACTIONS = exports.API_TRANSACTIONS = '/api/transactions';
var API_OPM = exports.API_OPM = '/api/opm';
var API_CMS = exports.API_CMS = '/api/cms';
var API_COUPONS = exports.API_COUPONS = '/api/coupons';
var API_SSO = exports.API_SSO = '/api/sso';
var API_IPOOLS = exports.API_IPOOLS = '/api/ipools';
var API_IPOOLS_POOL = exports.API_IPOOLS_POOL = '/api/ipools/pool';
var API_IPOOLS_POOL_ENTRIES = exports.API_IPOOLS_POOL_ENTRIES = '/api/ipools/pool/entries';
var API_IPOOLS_LEADERBOARD = exports.API_IPOOLS_LEADERBOARD = '/api/ipools/pool/leaderBoard';
var API_IPOOLS_POOL_ENTRY = exports.API_IPOOLS_POOL_ENTRY = '/api/ipools/pool/entry';
var API_MERLIN = exports.API_MERLIN = '/api/merlin';
var API_BLOG_POSTS = exports.API_BLOG_POSTS = '/api/blog-posts';
var API_VIRTUALS = exports.API_VIRTUALS = '/api/virtuals';
var API_VIRTUALS_GR = exports.API_VIRTUALS_GR = "".concat(API_VIRTUALS, "/goldenrace");
var API_VIRTUALS_VFL = exports.API_VIRTUALS_VFL = "".concat(API_VIRTUALS, "/vfl");
var API_GAMING_LICENSE = exports.API_GAMING_LICENSE = '/api/gaming_license';
var API_VERIFICATION = exports.API_VERIFICATION = '/api/verification';

/*
  Verification account
*/
var REGISTER_VERIFICATION = exports.REGISTER_VERIFICATION = '/register-verification';
var REGISTER_VERIFICATION_EMAIL = exports.REGISTER_VERIFICATION_EMAIL = '/check-email';
var API_CHANGE_ONE_TIME_PASSWORD = exports.API_CHANGE_ONE_TIME_PASSWORD = "".concat(API_SSO, "/password/onetime/change");
var VERIFY_EMAIL = exports.VERIFY_EMAIL = "".concat(API_VERIFICATION, "/verify");
var VERIFY_ALL = exports.VERIFY_ALL = "".concat(API_VERIFICATION, "/verify-all");
var RESEND_EMAIL = exports.RESEND_EMAIL = "".concat(API_VERIFICATION, "/verify-repeat-email");
var VERIFY_REPEAT_EMAIL_LOGIN = exports.VERIFY_REPEAT_EMAIL_LOGIN = "".concat(API_VERIFICATION, "/verify-repeat-email-login");
var VERIFY_PASSWORD = exports.VERIFY_PASSWORD = "".concat(API_VERIFICATION, "/verify-temp-password");
var DEBOUNCE_SEND_EMAIL_VERIFICATION = exports.DEBOUNCE_SEND_EMAIL_VERIFICATION = {
  TIMER: 120,
  // in seconds
  PART_KEY_REGISTRATION: 'timer_verification_',
  PART_KEY_LOGIN: 'timer_login_verification_'
};
var DEBOUNCE_RESET_PASSWORD = exports.DEBOUNCE_RESET_PASSWORD = {
  TIMER: 120,
  // in seconds
  PART_KEY_RESET: 'timer_reset_password_'
};

/*
  Logout
*/
var API_LOGOUT = exports.API_LOGOUT = "".concat(API_SSO, "/logout");

/*
  Validate login token
*/

var VALIDATE_TOKEN = exports.VALIDATE_TOKEN = "".concat(API_SSO, "/validate");

/*
 License
*/

var LICENSE_PATH = exports.LICENSE_PATH = '/gaming_license';

/*
  Reset password
*/
var RESET_PASSWORD_PATH = exports.RESET_PASSWORD_PATH = "".concat(API_SSO, "/password/reset/with-email");

/** setting unreal sport id for horseracing until new integration is ready */
var HORSERACING_ID = exports.HORSERACING_ID = '364';
var OUTRIGHT_FOOTBALL_MARKET_TYPE_ID = exports.OUTRIGHT_FOOTBALL_MARKET_TYPE_ID = '120';
var GREYHOUNDS_ID = exports.GREYHOUNDS_ID = '1000';
var FOOTBALL_SPORT_ID = exports.FOOTBALL_SPORT_ID = '240';
var BASKETBALL_SPORT_ID = exports.BASKETBALL_SPORT_ID = '227';
var TENNIS_SPORT_ID = exports.TENNIS_SPORT_ID = '239';
var FAVORITES = exports.FAVORITES = 'favorites';
var MIN_SEARCH_INPUT_VALUE_LENGTH = exports.MIN_SEARCH_INPUT_VALUE_LENGTH = 3;
var LIVE_ALL_SPORTS_ID = exports.LIVE_ALL_SPORTS_ID = 'allSports';
var INITIAL_STATE_VAR = exports.INITIAL_STATE_VAR = '__INITIAL_STATE__';
var RUNTIME_CONFIG = exports.RUNTIME_CONFIG = '__OSG_RUNTIME_CONFIG__';

/* BETGENIUS */

var BETGENIUS_CONFIG = exports.BETGENIUS_CONFIG = {
  srcEventsPrefix: '/resources/integration/BetgeniusIframeApi.js',
  liveScoreboard: {
    testRoot: '//offside.betstream.betgenius.com/betstream-view',
    prodRoot: '//offside.betstream.betgenius.com/betstream-view',
    availableSports: _defineProperty(_defineProperty(_defineProperty({}, TENNIS_SPORT_ID, {
      endpoint: '/betstream-view/getMappedFixtures/v1/product/offsidephoenixtennisscorecentre/sport/tennis?format=json',
      name: 'tennis',
      testRoot: '//offsidephoenix.betstream.betgenius.com/betstream-view',
      prodRoot: '//offsidephoenix.betstream.betgenius.com/betstream-view'
    }), FOOTBALL_SPORT_ID, {
      endpoint: '/betstream-view/offsidewsfootballscorecentre/getBookmakerMappedEvents?sportId=10',
      name: 'football'
    }), BASKETBALL_SPORT_ID, {
      endpoint: '/betstream-view/offsidewsbasketballscorecentre/getBookmakerMappedEvents?sportId=4',
      name: 'basketball'
    })
  }
};
var REGISTRATION_BONUS_COOKIE_KEY = exports.REGISTRATION_BONUS_COOKIE_KEY = 'bonus';
var IPOOLS_SETTLED_STATE_COOKIE = exports.IPOOLS_SETTLED_STATE_COOKIE = 'settled_pools';
var COOKIES_BANNER_COOKIE_KEY = exports.COOKIES_BANNER_COOKIE_KEY = 'osgCookiePolicyAccepted';
var COOKIES_BANNER_COOKIE_WITH_MARKETING_KEY = exports.COOKIES_BANNER_COOKIE_WITH_MARKETING_KEY = 'osgCookiePolicyWithMarketingConsent';
var BETSLIP_CONNECTION_ERROR = exports.BETSLIP_CONNECTION_ERROR = 'betslipConnectionError';
var GA_ATTRIBUTES_KEYS = exports.GA_ATTRIBUTES_KEYS = {
  BTN_CLICK: 'data-ga-btn-click',
  ACCOUNT_ID: 'data-ga-account-id',
  TOTAL_STAKE: 'data-ga-stake',
  CURRENCY: 'data-ga-currency'
};
var GA_ATTRIBUTES_VALUES = exports.GA_ATTRIBUTES_VALUES = {
  PLACE_BET: 'place-bet-button',
  LOGIN: 'login-button',
  REGISTRATION: 'registration-button',
  COOKIES: 'cookies-button'
};

// scoreboard background urls
var AMAZON_COMMON_BUCKET_URL = '//cdn.processingservices.biz';
var BACKGROUND_IMAGE_LIVE_BANNER_DEFAULT = exports.BACKGROUND_IMAGE_LIVE_BANNER_DEFAULT = "url(".concat(AMAZON_COMMON_BUCKET_URL, "/cms/uploads/default/live_sports_backgrounds/default.jpg)");
var BACKGROUND_IMAGE_LIVE_BANNER_AMERICANFOOTBALL = exports.BACKGROUND_IMAGE_LIVE_BANNER_AMERICANFOOTBALL = "url(".concat(AMAZON_COMMON_BUCKET_URL, "/cms/uploads/default/live_sports_backgrounds/american_football.jpg)");
var BACKGROUND_IMAGE_LIVE_BANNER_BADMINTON = exports.BACKGROUND_IMAGE_LIVE_BANNER_BADMINTON = "url(".concat(AMAZON_COMMON_BUCKET_URL, "/cms/uploads/default/live_sports_backgrounds/badminton.jpg)");
var BACKGROUND_IMAGE_LIVE_BANNER_BASEBALL = exports.BACKGROUND_IMAGE_LIVE_BANNER_BASEBALL = "url(".concat(AMAZON_COMMON_BUCKET_URL, "/cms/uploads/default/live_sports_backgrounds/koltron/baseball.png)");
var BACKGROUND_IMAGE_LIVE_BANNER_BASKETBALL = exports.BACKGROUND_IMAGE_LIVE_BANNER_BASKETBALL = "url(".concat(AMAZON_COMMON_BUCKET_URL, "/cms/uploads/default/live_sports_backgrounds/koltron/basketball.png)");
var BACKGROUND_IMAGE_LIVE_BANNER_BEACHSOCCER = exports.BACKGROUND_IMAGE_LIVE_BANNER_BEACHSOCCER = "url(".concat(AMAZON_COMMON_BUCKET_URL, "/cms/uploads/default/live_sports_backgrounds/beach_soccer.jpg)");
var BACKGROUND_IMAGE_LIVE_BANNER_BEACHVOLLEYBALL = exports.BACKGROUND_IMAGE_LIVE_BANNER_BEACHVOLLEYBALL = "url(".concat(AMAZON_COMMON_BUCKET_URL, "/cms/uploads/default/live_sports_backgrounds/beach_volleyball.jpg)");
var BACKGROUND_IMAGE_LIVE_BANNER_BOWLS = exports.BACKGROUND_IMAGE_LIVE_BANNER_BOWLS = "url(".concat(AMAZON_COMMON_BUCKET_URL, "/cms/uploads/default/live_sports_backgrounds/bowls.jpg)");
var BACKGROUND_IMAGE_LIVE_BANNER_DARTS = exports.BACKGROUND_IMAGE_LIVE_BANNER_DARTS = "url(".concat(AMAZON_COMMON_BUCKET_URL, "/cms/uploads/default/live_sports_backgrounds/darts.jpg)");
var BACKGROUND_IMAGE_LIVE_BANNER_FIELDHOCKEY = exports.BACKGROUND_IMAGE_LIVE_BANNER_FIELDHOCKEY = "url(".concat(AMAZON_COMMON_BUCKET_URL, "/cms/uploads/default/live_sports_backgrounds/field_hockey.jpg)");
var BACKGROUND_IMAGE_LIVE_BANNER_FOOTBALL = exports.BACKGROUND_IMAGE_LIVE_BANNER_FOOTBALL = "url(".concat(AMAZON_COMMON_BUCKET_URL, "/cms/uploads/default/live_sports_backgrounds/koltron/football.png)");
var BACKGROUND_IMAGE_LIVE_BANNER_FORMULA1 = exports.BACKGROUND_IMAGE_LIVE_BANNER_FORMULA1 = "url(".concat(AMAZON_COMMON_BUCKET_URL, "/cms/uploads/default/live_sports_backgrounds/formula1.jpg)");
var BACKGROUND_IMAGE_LIVE_BANNER_FUTSAL = exports.BACKGROUND_IMAGE_LIVE_BANNER_FUTSAL = "url(".concat(AMAZON_COMMON_BUCKET_URL, "/cms/uploads/default/live_sports_backgrounds/futsal.jpg)");
var BACKGROUND_IMAGE_LIVE_BANNER_HANDBALL = exports.BACKGROUND_IMAGE_LIVE_BANNER_HANDBALL = "url(".concat(AMAZON_COMMON_BUCKET_URL, "/cms/uploads/default/live_sports_backgrounds/handball.jpg)");
var BACKGROUND_IMAGE_LIVE_BANNER_ICEHOCKEY = exports.BACKGROUND_IMAGE_LIVE_BANNER_ICEHOCKEY = "url(".concat(AMAZON_COMMON_BUCKET_URL, "/cms/uploads/default/live_sports_backgrounds/koltron/hockey.png)");
var BACKGROUND_IMAGE_LIVE_BANNER_RUGBY = exports.BACKGROUND_IMAGE_LIVE_BANNER_RUGBY = "url(".concat(AMAZON_COMMON_BUCKET_URL, "/cms/uploads/default/live_sports_backgrounds/american_football.jpg)");
var BACKGROUND_IMAGE_LIVE_BANNER_SNOOKER = exports.BACKGROUND_IMAGE_LIVE_BANNER_SNOOKER = "url(".concat(AMAZON_COMMON_BUCKET_URL, "/cms/uploads/default/live_sports_backgrounds/snooker.jpg)");
var BACKGROUND_IMAGE_LIVE_BANNER_TABLETENNIS = exports.BACKGROUND_IMAGE_LIVE_BANNER_TABLETENNIS = "url(".concat(AMAZON_COMMON_BUCKET_URL, "/cms/uploads/default/live_sports_backgrounds/table_tennis.jpg)");
var BACKGROUND_IMAGE_LIVE_BANNER_TENNIS = exports.BACKGROUND_IMAGE_LIVE_BANNER_TENNIS = "url(".concat(AMAZON_COMMON_BUCKET_URL, "/cms/uploads/default/live_sports_backgrounds/koltron/tennis.png)");
var BACKGROUND_IMAGE_LIVE_BANNER_VOLLEYBALL = exports.BACKGROUND_IMAGE_LIVE_BANNER_VOLLEYBALL = "url(".concat(AMAZON_COMMON_BUCKET_URL, "/cms/uploads/default/live_sports_backgrounds/koltron/volleyball.png)");
var BACKGROUND_IMAGE_LIVE_BANNER_UFCMMA = exports.BACKGROUND_IMAGE_LIVE_BANNER_UFCMMA = "url(".concat(AMAZON_COMMON_BUCKET_URL, "/cms/uploads/default/live_sports_backgrounds/koltron/ufcmma.png)");
var BACKGROUND_IMAGE_LIVE_BANNER_CRYPTO = exports.BACKGROUND_IMAGE_LIVE_BANNER_CRYPTO = "url(".concat(AMAZON_COMMON_BUCKET_URL, "/cms/uploads/default/live_sports_backgrounds/koltron/crypto.png)");
var BACKGROUND_IMAGE_LIVE_BANNER_ESPORTS = exports.BACKGROUND_IMAGE_LIVE_BANNER_ESPORTS = BACKGROUND_IMAGE_LIVE_BANNER_DEFAULT;
var BACKGROUND_IMAGE_LIVE_BANNER_RUGBYLEAGUE = exports.BACKGROUND_IMAGE_LIVE_BANNER_RUGBYLEAGUE = BACKGROUND_IMAGE_LIVE_BANNER_DEFAULT;
var BACKGROUND_IMAGE_LIVE_BANNER_CRICKET = exports.BACKGROUND_IMAGE_LIVE_BANNER_CRICKET = BACKGROUND_IMAGE_LIVE_BANNER_DEFAULT;
var BACKGROUND_IMAGE_LIVE_BANNER_HORSERACING = exports.BACKGROUND_IMAGE_LIVE_BANNER_HORSERACING = "url(".concat(AMAZON_COMMON_BUCKET_URL, "+\"/cms/uploads/default/live_sports_backgrounds/horseracingBack2.jpg\") no-repeat center center,\nurl(").concat(AMAZON_COMMON_BUCKET_URL, "+\"/cms/uploads/default/live_sports_backgrounds/horseracingBack1.jpg\") no-repeat center center");
var BACKGROUND_IMAGE_LIVE_BANNER_GREYHOUNDS = exports.BACKGROUND_IMAGE_LIVE_BANNER_GREYHOUNDS = "url(".concat(AMAZON_COMMON_BUCKET_URL, "+\"/cms/uploads/default/live_sports_backgrounds/greyhoundsBack2.jpg\") no-repeat center center,\nurl(").concat(AMAZON_COMMON_BUCKET_URL, "+\"/cms/uploads/default/live_sports_backgrounds/greyhoundsBack1.jpg\") no-repeat center center");
var SPORT_IDS = exports.SPORT_IDS = {
  '1': 'American Football',
  '215': 'Cricket',
  '226': 'Baseball',
  '227': 'Basketball',
  '228': 'Ice Hockey - US',
  '231': 'Canadian Football',
  '237': 'Golf',
  '238': 'Boxing',
  '239': 'Tennis',
  '240': 'Football',
  '364': 'Horse Racing',
  '365': 'US Horse Racing',
  '366': 'US Greyhound Racing',
  '900': 'Yachting',
  '1000': 'Greyhound Racing',
  '1100': 'Handball',
  '1200': 'Volleyball',
  '1201': 'UFC/MMA',
  '1202': 'Wrestling',
  '1203': 'Winter Olympics',
  '1206': 'Horse Racing Futures and Props',
  '1250': 'Beach Volleyball',
  '1300': 'Formula 1',
  '1400': 'Water Polo',
  '1500': 'Beach Soccer',
  '1600': 'Futsal',
  '1700': 'Bandy',
  '1750': 'Chess',
  '1800': 'Biathlon',
  '1900': 'Table Tennis',
  '2000': 'Lottery',
  '2100': 'Ice Hockey',
  '2200': 'MotoGP',
  '2300': 'Rally WRC',
  '2400': 'Swimming',
  '2500': 'Rugby 7s',
  '2600': 'Motorcycling',
  '2700': 'Cycling',
  '2800': 'Nine-Ball Pool',
  '2900': 'Winter Sports',
  '3000': 'Gaelic Games',
  '3100': 'Olympic Games',
  '3200': 'Football Specials',
  '3300': 'Curling',
  '3400': 'Bowls',
  '3500': 'Field Hockey',
  '3600': 'Floorball',
  '3700': 'Australian Rules Football',
  '3800': 'Skiing',
  '3900': 'Rink Hockey',
  '4011': 'Nascar',
  '4012': 'DTM',
  '5000': 'Badminton',
  '6000': 'E-Sports',
  '6012': 'Alpine Skiing',
  '6013': 'Cross-Country',
  '6014': 'Ski-Jumping',
  '6015': 'Freestyle Skiing',
  '6016': 'Snowboard',
  '6017': 'Nordic Combined',
  '6018': 'Figure Skating',
  '7000': 'Gymnastics',
  '22877': 'Rugby Union',
  '22878': 'Rugby League',
  '22881': 'Motor Sports',
  '22883': 'Tennis Specials',
  '22884': 'Snooker',
  '22885': 'Athletics',
  '22886': 'Darts',
  '22887': 'Poker',
  '22888': 'Politics',
  '22889': 'Entertainment',
  '22890': 'Speedway',
  '8000': 'Judo',
  '9000': 'Bitcoin',
  '6007': 'Bobsleigh',
  '6008': 'Skeleton',
  '6009': 'LUGE',
  '6010': 'Speed Skating',
  '6011': 'Short-Track Speed Skating'
};

/** CACHE TIME */
var TIME_CACHE_LICENSE = exports.TIME_CACHE_LICENSE = 60 * 60; // seconds
var TIME_CACHE_SEO_FILES = exports.TIME_CACHE_SEO_FILES = 30 * 24 * 60 * 60; // seconds

var INBOUND_API = exports.INBOUND_API = '/api/inbound';
var BG_STREAMS_URL = exports.BG_STREAMS_URL = "".concat(INBOUND_API, "/geniussports/streams");
var TRUSTLY_URL = exports.TRUSTLY_URL = "".concat(INBOUND_API, "/trustly");
var TRUSTLY_REGISTRATION = exports.TRUSTLY_REGISTRATION = "".concat(TRUSTLY_URL, "/registration");
var TRUSTLY_LOGIN = exports.TRUSTLY_LOGIN = "".concat(TRUSTLY_URL, "/login");
var TRUSTLY_DEPOSIT = exports.TRUSTLY_DEPOSIT = "".concat(TRUSTLY_URL, "/deposit");
var TRUSTLY_WITHDRAWAL = exports.TRUSTLY_WITHDRAWAL = "".concat(TRUSTLY_URL, "/withdrawal");
var TRUSTLY_TOKEN = exports.TRUSTLY_TOKEN = "".concat(TRUSTLY_URL, "/token");